import React from "react";
import DreamerLineChart from "@/components/DreamerCharts/DreamerLineChart";
import {
  DreamerLineChartDataType,
  LineConfig
} from "@/components/DreamerCharts/types";

interface Props {
  height: number | string;
  chartData: DreamerLineChartDataType[];
  lines: LineConfig[];
  isPercentage?: boolean;
  showGrid?: boolean;
  yAxisDomain?: [number, number];
  legendClassName?: string;
  compact?: boolean;
}

const DreamerMultiLineChart: React.FC<Props> = (props) => (
  <DreamerLineChart {...props} showLegend />
);

export default DreamerMultiLineChart;
